<script setup>
import { useCartStore } from "@/stores/cart.store";
import { useProductsStore } from "@/stores/products.store";
import { useRouter } from "vue-router";

const router = useRouter();
const productStore = useProductsStore();
const cartStore = useCartStore();
const showDropdown = ref(false);
const selectedArea = ref({
    name: "منطقة الرياض",
    id: 1
});
const deliveryAreas = ref([{
    name: "منطقة الرياض",
    id: 1
}, {
    name: "منطقة الشرقية",
    id: 2
}]);

// دالة لتبديل حالة المودال
const toggleDropdown = () => {
    showDropdown.value = !showDropdown.value;
};

function getArias() {
    for (let index = 0; index < productStore.cities.length; index++) {
        const city = productStore.cities[index];
        deliveryAreas.value[index] = city;
    }
}

watch(() => productStore.cities, () => {
    getArias()
});

// تحديد المنطقة 
const selectArea = (area) => {
    const oldArea = selectedArea.value;
    selectedArea.value = area;


    if (oldArea.id === area.id) {
        showDropdown.value = false;
        return;
    }


    productStore.selectedAria = productStore.cities.filter(city => city.id === area.id)[0];

    showDropdown.value = false;
    cartStore.clearCart();
    localStorage.setItem("selectedAria", JSON.stringify(productStore.selectedAria))
    productStore.fetchVersionAndUpdateProducts()
    router.push('/');
};

const onSearch = (searchValue) => {
    productStore.setSearchQuery(searchValue.target.value); // تحديث النص المدخل في المخزن
};

const onSearchEnter = (event) => {
    event.target.blur(); // Hide the keyboard on mobile when pressing Go/Enter
};
</script>

<template>
<nav id="tazej-main-navbar" class="bg-tazej-green-primary w-full sticky top-0 z-40">
    <div
        class="flex items-center justify-between gap-2 p-4 w-full max-w-[1600px] mx-auto lg:px-8 lg:py-3 xl:px-10">
    <div class="flex items-center gap-2 lg:gap-3 shrink-0 min-w-0">
        <router-link to="/" class="max-w-11 shrink-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80 rounded-md">
            <img src="../../public/img/logo-white.png" alt="طازج الغذائية" width="56" height="56" class="w-12 h-12 lg:w-14 lg:h-14 object-contain" />
        </router-link>
        <router-link
            to="/blog"
            class="text-white text-sm lg:text-base font-semibold whitespace-nowrap hover:underline underline-offset-4 shrink-0 px-1"
        >
            المدونة
        </router-link>
        <router-link
            to="/recipes"
            class="text-white text-sm lg:text-base font-semibold whitespace-nowrap hover:underline underline-offset-4 shrink-0 px-1"
        >
            الوصفات
        </router-link>
    </div>

    <div
        class="flex items-center mx-2 border rounded-full max-w-48 min-w-40 h-8 justify-center lg:flex-1 lg:max-w-xl lg:min-w-0 lg:h-9 lg:mx-4 xl:max-w-2xl">
        <div class="px-3 lg:px-4 items-center flex justify-center shrink-0">
            <font-awesome-icon class="text-white w-5 h-5" :icon="['fas', 'search']" />
        </div>
        <input @input="onSearch($event)" 
               @keydown.enter="onSearchEnter($event)"
               type="text" id="searchInput" placeholder="ابحث عن منتج..."
               class="border-none w-full h-full bg-white rounded-r-none rounded-full outline-none pr-3 lg:pr-4 text-sm lg:text-base min-w-0" />
    </div>

    <div class="relative shrink-0">
        <!-- عنوان التوصيل -->
        <div class="text-base lg:text-lg mx-2 lg:mx-4 mb-1 text-white mb-1 cursor-pointer" style="white-space: nowrap" @click="toggleDropdown">
            عنوان التوصيل
        </div>

        <!-- خلفية مظللة للشاشة عند فتح المودال -->
        <div v-if="showDropdown" class="fixed inset-0 bg-black opacity-50 z-40" @click="toggleDropdown"></div>

        <!-- المودال (في نفس مكان القائمة المنسدلة) -->
        <div v-if="showDropdown"
            class="absolute top-full mt-2 bg-white shadow-lg border border-gray-300 rounded-md w-full z-50 lg:min-w-56 lg:shadow-xl">
            <div v-for="(area) in deliveryAreas" @click="selectArea(area)"
                class="flex justify-between items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
                <!-- أيقونة التحقق -->
                <svg v-if="area.name === selectedArea.name" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" class="w-6 h-6">
                    <circle cx="12" cy="12" r="10" fill="#FFA500" stroke="none" />
                    <path d="M8 12l2 2 4-4" stroke="#fff" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                <!-- اسم المنطقة -->
                <span :class="{ 'font-semibold text-orange-500': area.name === selectedArea.name }"
                    class="flex-1 text-xs text-center">
                    {{ area.name }}
                </span>
            </div>
        </div>
    </div>
    </div>
</nav>
</template>
